<div class="wrapper is-flex">
  <ng-content />
</div>
